import React, { useEffect } from 'react';
import { getRazorPayKey } from '../../../appconfig';
import { WidgetContainer } from './styled';

function AffordibilityWidget(props) {
  const { price, productId, stroller } = props;
  const key = getRazorPayKey();
  const amount = price * 100;
  useEffect(() => {
    const widgetConfig = {
      key: key,
      amount: amount,
      theme: {
        color: '#63b0a9',
      },
      display: {
        offers: {
          offerIds: ['offer_MBzfZ2zOzBaMDU'],
        },
        widget: {
          main: {
            heading: {
              fontSize: '14px',
            },
            link: {
              color: '#ef4e5e',
            },
          },
        },
      },
    };
    const rzpAffordabilitySuite = new RazorpayAffordabilitySuite(widgetConfig);
    rzpAffordabilitySuite.render();
    let iframe = document.getElementById('rzpAffordabilityMainFrame');
    iframe?.setAttribute('scrolling', 'no');
    let iframePopup = document.getElementById('rzpAffordabilityDetailFrame');
    iframePopup?.setAttribute('scrolling', 'no');
  }, [productId]);

  return (
    <WidgetContainer
      stroller={stroller}
      id="razorpay-affordability-widget"
    ></WidgetContainer>
  );
}

export default AffordibilityWidget;
